import { useKeycloak } from '@react-keycloak/web';
import {  Route } from 'react-router-dom';



export function PrivateRoute( {component:Component, roles, ...rest}:any ) {
    const {keycloak} = useKeycloak();

    const isAuthorized = (roles:any) => {

        if (keycloak && roles) {
            return roles.some((r:any) => {
                return keycloak.authenticated
            });
        }
        return true;
    }

    return (
        <Route
            {...rest}
            render={(props:any) => {
                return isAuthorized(roles)
                    ? <Component {...props} />
                    : keycloak.login()
            }}
        />
    )
}

export default PrivateRoute
